'use client';

import React, { useRef } from 'react';
import { useServerInsertedHTML } from 'next/navigation';
import { Provider as StyletronProvider } from 'styletron-react';
import { Client, Server } from 'styletron-engine-atomic';

export function StyletronRegistry({ children }: { children: React.ReactNode }) {
  const engineRef = useRef<Server | Client>(
    typeof window === 'undefined'
      ? new Server()
      : new Client({
          hydrate: document.querySelectorAll(
            '._styletron_hydrate_'
          ) as unknown as NodeListOf<HTMLStyleElement>,
        })
  );

  useServerInsertedHTML(() => {
    const engine = engineRef.current;
    if (!(engine instanceof Server)) return null;
    const sheets = engine.getStylesheets();
    if (!sheets.length) return null;
    return (
      <>
        {sheets.map(({ css, attrs }, i) => (
          <style key={i} {...attrs} dangerouslySetInnerHTML={{ __html: css }} />
        ))}
      </>
    );
  });

  return (
    <StyletronProvider value={engineRef.current as Client} debugAfterHydration>
      {children}
    </StyletronProvider>
  );
}
